<template>
  <div class="box">
    <p class="heading">Create Licence</p>
    <b-field label="Owner Email">
      <b-input type="email" v-model="ownerEmail" />
    </b-field>
    <b-field label="Seats">
      <b-numberinput v-model="seats" />
    </b-field>
    <b-field label="Months">
      <b-numberinput v-model="months" />
    </b-field>
    <b-button
      @click="createLicence()"
      type="is-primary"
      :loading="creating"
      expanded
    >
      Create Licence
    </b-button>
  </div>
</template>

<script>
import dataService from "../../services/dataService";

export default {
  data() {
    return {
      seats: 10,
      months: 6,
      ownerEmail: "",
      creating: false
    };
  },
  methods: {
    async createLicence() {
      this.creating = true;
      await dataService.createLicenceAsAdmin(
        this.ownerEmail,
        this.seats,
        this.months
      );
      this.creating = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
